module.exports = __webpack_public_path__ + "static/media/recipiente.2dcc5c20.jpg";